// copied from chatgpt
export function camelToTitleCase(str: string) {
  // Insert a space before each uppercase letter, then convert the whole string to title case
  return str
    .replace(/([a-z0-9])([A-Z])/g, "$1 $2") // Add space before uppercase letters
    .replace(/^./, (match: string) => match.toUpperCase()) // Capitalize the first letter
    .replace(/([A-Z])([A-Z][a-z])/g, "$1 $2"); // Fix cases like 'XMLHttpRequest' -> 'XML Http Request'
}
